/**
*
* LandingCard
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Div, FlexBox } from '../Blocks';
import ButtonGroup from '../ButtonGroup';
import media from '../../style/mediainjector';
import { H2, P } from '../Typography';
import { ActionButton, ActionButtonA } from '../Button';

export const LegalInfo = styled(P)`
  font-size: 12px;
  label {
    display:inline-block;
  }
  ${media.lt480`
    font-size: 10px;
  `}
`;

export const FlexSwitch = styled(FlexBox)`
  width: 100%;
  padding: 0;
  justify-content: space-between;
  ${media.lt667`
    flex-direction: column;
  `}
`;

export const Image = styled.img`
  width: 25%;
  ${(props) => props.halfSplit && css`
    width: 50%;
  `}
  order: ${(props) => props.flexorder};
  align-self: ${(props) => props.alignThumb};
  ${media.lt667`
    width: 65%;
    margin: 10px 30px 30px;
    align-self: center;
  `}
`;

export const CardBox = styled.div`
  width: 80%;
  max-width: 640px;
  padding: ${(props) => (props.padding ? props.padding : '0 0 0 30px')};
  ${({ inverse }) => inverse === 2 && css`
    padding: 0 30px 0 0;
  `};
  ${media.lt667`
    width: 100%;
    max-width: 100%;
    padding: 0;
    h2 {
      font-size: 2.4rem;
    }
  `}
  a {
    color: #FFFFFF;
  }
`;

export const Body = styled(Div)`
  margin: 1em auto 1.5em;
  a {
    color: inherit;
  }
`;

class LandingCard extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const {
      flexorder,
      title,
      src,
      body,
      // FIXME: a tenndere la prop actionButton va rimossa in favore di actionButtons
      actionButton,
      actionButtons = [],
      action,
      secondAction,
      color,
      titleColor,
      buttonBgcolor,
      buttonShadow,
      buttonShadowPlus,
      buttonBone,
      footNote,
      alignThumb,
      columnDirection,
      halfSplit,
    } = this.props;

    return (
      <FlexSwitch maxWidth="820px" direction={columnDirection}>
        {src && <Image src={src} role="presentation" direction={columnDirection} flexorder={flexorder} alignThumb={alignThumb} halfSplit={halfSplit} />}
        <CardBox inverse={flexorder}>
          <H2 color={titleColor} margin="0">{title}</H2>
          {body && (
            <Body
              color={color}
              dangerouslySetInnerHTML={{ __html: body }}
            />
          )}
          <ButtonGroup bottomSpace="30px" justifyContent="flex-start">
            {actionButtons.length > 0 && actionButtons.map(({
              text, onClickFunction, id, bgColor, shadow, bone, shadowPlus,
            }) => (
              <ActionButton
                key={`action_button_${id}`}
                sectionbutton={1}
                bgcolor={bgColor}
                // bgcolor="red"
                shadow={shadow}
                shadowPlus={shadowPlus}
                onClick={onClickFunction}
                bone={bone}
              >
                {text}
              </ActionButton>
            ))}
            {actionButton && (
              <ActionButton
                sectionbutton={1}
                bgcolor={buttonBgcolor}
                shadow={buttonShadow}
                shadowPlus={buttonShadowPlus}
                onClick={actionButton.onClickFunction}
                bone={buttonBone}
              >
                {actionButton.text}
              </ActionButton>
            )}
            {action && action.text
              ? (
                <ActionButtonA sectionbutton={1} bone={1} to={action.link}>
                  {action.text}
                </ActionButtonA>
              ) : ''}
            {secondAction && secondAction.text
              ? (
                <ActionButtonA sectionbutton={1} bone={1} to={secondAction.link}>
                  {secondAction.text}
                </ActionButtonA>
              ) : ''}
          </ButtonGroup>
          {footNote && (
            <LegalInfo margin="12px 12px 0 12px" color={footNote.color}>
              {footNote.text}
            </LegalInfo>
          )}
        </CardBox>
      </FlexSwitch>
    );
  }
}

LandingCard.defaultProps = {
  action: {},
};

LandingCard.propTypes = {
  color: PropTypes.string,
  titleColor: PropTypes.string,
  buttonBgcolor: PropTypes.string,
  buttonBone: PropTypes.bool,
  buttonShadow: PropTypes.bool,
  buttonShadowPlus: PropTypes.bool,
  src: PropTypes.string,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  flexorder: PropTypes.number,
  alignThumb: PropTypes.string,
  columnDirection: PropTypes.bool,
  halfSplit: PropTypes.bool,
  action: PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
  }),
  secondAction: PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
  }),
  actionButton: PropTypes.shape({
    text: PropTypes.string,
    richiediCodice: PropTypes.func,
    bgcolor: PropTypes.string,
    shadow: PropTypes.string,
    shadowPlus: PropTypes.string,
    onClickFunction: PropTypes.func,
  }),
  actionButtons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  ),
  footNote: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string,
  }),
};

export default LandingCard;
